var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatcontact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.001,
    height: 30,
    viewBox: "0 0 30.001 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12433 -10724)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    d: "M30,30H4a2,2,0,0,1-2-2V24H4a1,1,0,1,0,0-2H2V19H4a1,1,0,1,0,0-2H2V14H4a1,1,0,1,0,0-2H2V9H4A1,1,0,1,0,4,7H2V2A2,2,0,0,1,4,0H30a2,2,0,0,1,2,2V28A2,2,0,0,1,30,30Z",
    transform: "translate(12431 10724)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12418.222 10347.952)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.778 383.048)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.203)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c1d4f8",
    d: "M115.089,0a4.3,4.3,0,1,0,4.3,4.3A4.31,4.31,0,0,0,115.089,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.349)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9dbafc",
    d: "M39.133,250.968a3.993,3.993,0,0,0-.437-.788,5.416,5.416,0,0,0-3.743-2.327.808.808,0,0,0-.551.131,4.684,4.684,0,0,1-5.472,0,.719.719,0,0,0-.551-.131,5.377,5.377,0,0,0-3.743,2.327,4.6,4.6,0,0,0-.437.788.4.4,0,0,0,.019.357,7.483,7.483,0,0,0,.513.751,7.164,7.164,0,0,0,.874.976,11.349,11.349,0,0,0,.874.751,8.749,8.749,0,0,0,10.336,0,8.325,8.325,0,0,0,.874-.751,8.7,8.7,0,0,0,.874-.976,6.577,6.577,0,0,0,.513-.751A.317.317,0,0,0,39.133,250.968Z",
    transform: "translate(-24.165 -247.841)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatcontact);
export default __webpack_public_path__ + "static/media/chatcontact.f2dd5342cd3938b8a6853b4cae18c89d.svg";
export { ForwardRef as ReactComponent };